import React, { Component } from 'react';
import { connect } from "react-redux";
import { getVunnenMonthChartByUserid,setofUpdatedashboard } from 'actions'
import CircularProgress from "../../CircularProgress/ExtraLargeCircularProgress";
import CustomMenu from "../../CustomMenu";
import {isEmpty,isUndefined} from 'lodash'
import {NumberFormat} from 'components/NotyNumberFormat' 
import IntlMessages from 'util/IntlMessages';
class Progress extends Component {
    state={
        DashboardFilterOption:[],
        done: false
    }
    intervalID = null
    componentDidMount=()=>{
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        const isFrom= isUndefined(this.props.isFrom)?0:1
        if(isFrom=== 1){
            this.props.getVunnenMonthChartByUserid(userid,Afid,[])
            .then(() => {
                this.setState({done: true})   
            })
        }
        else{
            this.props.getVunnenMonthChartByUserid(userid,Afid,this.props.DashboardFilterOption)
            .then(() => {
                this.setState({done: true})   
            })
        }
        this.intervalID = setInterval(
            () => {
                if(this.state.done === true){            
                    this.setState({done: false}) 
                const userid = this.props.authUser.user_id;
                const Afid = this.props.authUser.user_Afid;
                const isFrom= isUndefined(this.props.isFrom)?0:1
                if(isFrom=== 1){
                    this.props.getVunnenMonthChartByUserid(userid,Afid,[])
                    .then(() => {
                        this.setState({done: true})   
                    })
                }
                else{
                    this.props.getVunnenMonthChartByUserid(userid,Afid,this.props.DashboardFilterOption)
                    .then(() => {
                        this.setState({done: true})   
                    })
                }
                }
             },
               180000
        );
        
        
    }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID= null
    }
    componentDidUpdate=()=>{
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        if(parseInt(this.props.updatedashboard) === 1){
            this.props.getVunnenMonthChartByUserid(userid,Afid,this.props.DashboardFilterOption)
                .then(() => {
                    this.setState({done: true})   
                })
            this.props.setofUpdatedashboard()
        }
     const isFrom= isUndefined(this.props.isFrom)?0:1
        if(isFrom=== 1){
      /*         setTimeout(()=> {
                const userid = this.props.authUser.user_id;
                const Afid = this.props.authUser.user_Afid;
                this.props.getVunnenMonthChartByUserid(userid,Afid,[])
            }, 30000);*/
        }
        else{
          /*   setTimeout(()=> {
                const userid = this.props.authUser.user_id;
                const Afid = this.props.authUser.user_Afid;
                this.props.getVunnenMonthChartByUserid(userid,Afid,this.props.DashboardFilterOption)
            }, 30000);*/
            if(this.props.DashboardFilterOption !== this.state.DashboardFilterOption)
            {
         /* */       
                this.props.getVunnenMonthChartByUserid(userid,Afid,this.props.DashboardFilterOption)
                .then(() => {
                    this.setState({done: true})   
                })
               this.setState({
                    DashboardFilterOption:this.props.DashboardFilterOption 
                }) 
            }
        }
        
    }
    formatNumber=(number)=>{
        
        if(number > 1000000){
            return `${(number/1000).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$& ')}K`
        }else if(number > 1000){
            return `${(number/1000).toFixed(0)}K`
        }else{
            return parseInt(number)
        }
    }
    formatNumber2=(number)=>{
        return NumberFormat(number, 'standard', 'auto', 0)
      if(number > 1000000){
          return `${(number/1000).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$& ')}K`
      }else if(number > 1000){
          return `${(number/1000).toFixed(0)}K`
      }else{
          return parseInt(number)
      }
    }
    render() {
        const formatter = new Intl.NumberFormat('fr',
        { notation: "compact" , compactDisplay: "short" }
        )
        let Budget = (this.props.UserBudget=== 0)?100:this.props.UserBudget
        //console.log(Budget)
        //console.log(parseInt((this.props.MonthVunnen/Budget)*100))
        //d-flex justify-content-center flex-column
        return (
            <div className="text-center" style={{ color: 'white' }}>
                
                <div className="" 
                style={{ marginTop: '12px' }}>
                    <h2 className="col m-0 p-0" style={{fontWeight:"300"}}><b><IntlMessages id="Sales"/></b></h2>
                    <h4 className="col m-0 p-0" style={{fontWeight:"300"}}><b><IntlMessages id="Outcome.Budget"/></b></h4>                    
                  {/*  <div style={{ marginTop: '-14px', marginRight:'10px' }}>
                        <CustomMenu />
                    </div>
                    */}
                </div>
                <div className="d-flex justify-content-center" style={{ marginTop: '10px' }}>
                    <div style={{zIndex: 0}} className="position-absolute">
                        <CircularProgress 
                        Budget={Budget} 
                        MonthVunnen={this.props.MonthVunnen} 
                        percentage={parseInt((this.props.MonthVunnen/Budget)*100)}/>
                    </div>
                    <div style={{marginTop:'4rem', fontSize:30,fontWeight:"300"}} className="position-relative">
                        <p>{this.formatNumber2(this.props.MonthVunnen)}</p>
                        {
                            parseInt(this.props.authUser.user_canSeeTB1)===1?
                            <p style={{fontSize:18}}><small>({this.formatNumber(this.props.TB1MonthVunnen)})</small></p>
                            :""
                        }  
                    </div>
                </div>
                <div>
                    <p style={{fontSize:20, marginTop:'0',fontWeight:"300"}}>{parseInt((this.props.MonthVunnen/Budget)*100)}%</p>
                </div>
                <div className="d-flex justify-content-end" 
                style={{marginTop:'3.1rem', color:'#075a5f', marginRight:'8px'}}>
                    <b style={{fontSize:20,fontWeight:"300"}}>/ {this.formatNumber((this.props.UserBudget=== 0)?0:this.props.UserBudget)}</b>
                </div>
            </div>
        )
    }
}
const mapStateToProps = ({ settings,auth,DashBoard,accountsData }) => {
    const { width } = settings;
    const { authUser} = auth;
    const { updatedashboard} = accountsData;
    const { UserBudget,MonthVunnen,DashboardFilterOption,TB1MonthVunnen} = DashBoard;
    return { width,authUser,UserBudget,MonthVunnen,DashboardFilterOption,TB1MonthVunnen,updatedashboard };
  };
  function mapDispatchToProps(dispatch) {
    return {
      getVunnenMonthChartByUserid: (userid,Afid,DashboardFilterOption) => dispatch(getVunnenMonthChartByUserid(userid,Afid,DashboardFilterOption)),
      setofUpdatedashboard: () => dispatch(setofUpdatedashboard()),
        dispatch
    }
  }
export default connect(mapStateToProps,mapDispatchToProps)(Progress);
